import React, { FC, useState } from 'react'
import { MasterDataTable } from '../DataTable/MasterDataTable';
import { TableColumn } from 'react-data-table-component';
import { useIntl } from 'react-intl';
import { Notification } from '../../interfaces/NotificationLog/notification';
import moment from 'moment-timezone';
import DetailNotificationLog from './DetailNotificationLog';
import useNotificationStore from '../../stores/Notification';

const TabReadNotification: FC = () => {
  const intl = useIntl()
  const [notification, setNotification] = useState<Notification | null>(null);
  const [showNotificationDetail, setShowNotificationDetail] = useState<boolean>(false);
  const { startDate, endDate } = useNotificationStore()

  const onRowClicked = (row: Notification) => {
    setNotification(row)
    setShowNotificationDetail(true);
  };

  const baseTableColumns: TableColumn<Notification>[] = [
    {
      name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TITLE' }),
      style: { cursor: "pointer", flexWrap: "wrap" },
      width: '300px',
      sortable: true,
      selector: row => row.title || '',
    },
    {
      name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DESCRIPTION' }),
      style: { cursor: "pointer" },
      wrap: true,
      allowOverflow: true,
      width: '400px',
      sortable: true,
      selector: row => row.body || '',
    },
    {
      name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TYPE_NOTIFICATION' }),
      style: { cursor: "pointer" },
      width: '250px',
      sortable: true,
      wrap: true,
      allowOverflow: true,
      selector: row => row.type || '',
      cell: row => {
        if (row.type === 'TERMIN.REMINDER') {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2 bg-light-warning p-2 rounded">
              <i className="fas fa-money-bill-wave text-warning fs-4"></i>
              <p className='my-auto fw-semibold text-warning'>Termin Reminder</p>
            </div>
          )
        }
        if (row.type === 'REIMBURSEMENT.INFO') {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2 bg-light-success p-2 rounded">
              <i className="fas fa-wallet text-success fs-4"></i>
              <p className='my-auto fw-semibold text-success'>Reimbursement Info</p>
            </div>
          )
        }
        if (row.type === 'LOG.INFO') {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2 bg-light-info p-2 rounded">
              <i className="fas fa-file-alt text-info fs-4"></i>
              <p className='my-auto fw-semibold text-info'>Log Info</p>
            </div>
          )
        }
        if (row.type === 'MEETING.INFO') {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2 bg-light-primary p-2 rounded">
              <i className="fas fa-calendar-check text-primary fs-4"></i>
              <p className='my-auto fw-semibold text-primary'>Meeting Info</p>
            </div>
          )
        }
        if (row.type === 'PIPELINE.INFO') {
          return (
            <div className="d-flex justify-content-center align-items-center gap-2 bg-light-danger p-2 rounded">
              <i className="fas fa-stream text-danger fs-4"></i>
              <p className='my-auto fw-semibold text-danger'>Pipeline Info</p>
            </div>
          )
        }
        return (
          <div className="d-flex justify-content-center align-items-center gap-2 bg-light-secondary p-2 rounded">
            <i className="fas fa-bell text-secondary fs-4"></i>
            <p className='my-auto fw-semibold text-secondary'>Info</p>
          </div>
        )
      },
    },
    {
      name: intl.formatMessage({ id: 'MASTERS.DATATABLE.TYPE.DATE_CREATED' }),
      style: { cursor: "pointer" },
      width: '150px',
      sortable: true,
      selector: row => moment(row.createdtime).format('DD MMM YYYY HH:mm') || '',
    },
  ];

  return (
    <>
      <MasterDataTable
        tableKey="readNotification"
        tableColumns={baseTableColumns}
        // actions={actionsBroadcastEmail}
        apiURL={`crm-notifications/data-read${startDate ? `?date_start=${moment(startDate).format('YYYY-MM-DD')}` : ''}${endDate ? `&date_end=${moment(endDate).format('YYYY-MM-DD')}` : ''}`}
        onRowClicked={onRowClicked}
      />

      {
        showNotificationDetail && (
          <DetailNotificationLog
            open={showNotificationDetail}
            onClose={() => setShowNotificationDetail(false)}
            notification={notification as Notification}
          />
        )
      }
    </>
  )
}

export default TabReadNotification